import { call, put, select, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchList,
    listFetched,
    listFetchFailed,
    fetchMore,
    moreFetched,
    moreFetchFailed,
    runDeepQueue,
    startDeepVerify,
    deepResultReceived,
    deepResultFailed,
    fetchDetail,
    detailFetched,
    detailFetchFailed,
    recalculateInvoice,
    recalculateInvoiceSucceeded,
    recalculateInvoiceFailed,
} from '../weeklyInvoiceVerification';

function* fetchListEffect({ payload }) {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.weeklyInvoiceVerification,
            method: 'GET',
            queryParams: payload || {},
        });
        yield put(listFetched(response));
        // kick off the deep-verify queue for the page just loaded
        yield put(runDeepQueue());
    } catch (e) {
        yield put(listFetchFailed(e.message));
    }
}

function* fetchMoreEffect({ payload }) {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.weeklyInvoiceVerification,
            method: 'GET',
            queryParams: payload || {},
        });
        yield put(moreFetched(response));
        yield put(runDeepQueue());
    } catch (e) {
        yield put(moreFetchFailed(e.message));
    }
}

function* fetchDetailEffect({ payload }) {
    // if we already have a cached deep result, the reducer in fetchDetail
    // already promoted it into selectedDetail — skip the network call
    const cached = yield select(
        s => s.weeklyInvoiceVerification.deepResults[payload],
    );
    if (cached) return;
    try {
        const response = yield call(SendApiRequest, {
            url: `${apiRoutes.weeklyInvoiceVerification}/${payload}`,
            method: 'GET',
        });
        yield put(detailFetched(response));
    } catch (e) {
        yield put(detailFetchFailed(e.message));
    }
}

function* recalculateInvoiceEffect({ payload }) {
    try {
        const response = yield call(SendApiRequest, {
            url: `${apiRoutes.weeklyInvoiceVerification}/${payload}/recalculate`,
            method: 'POST',
        });
        yield put(recalculateInvoiceSucceeded(response));
    } catch (e) {
        yield put(recalculateInvoiceFailed(e.message));
    }
}

// Process the deep-verify queue ONE invoice at a time. Each new list page
// (via takeLatest) cancels any in-flight queue and restarts.
function* deepQueueEffect() {
    while (true) {
        const next = yield select(s => {
            const q = s.weeklyInvoiceVerification.queuedIds;
            return q.length ? q[0] : null;
        });
        if (!next) return;
        yield put(startDeepVerify(next));
        try {
            const response = yield call(SendApiRequest, {
                url: `${apiRoutes.weeklyInvoiceVerification}/${next}`,
                method: 'GET',
            });
            yield put(deepResultReceived({ id: next, result: response }));
        } catch (e) {
            yield put(deepResultFailed({ id: next, error: e.message }));
        }
    }
}

export const weeklyInvoiceVerificationSagas = [
    takeLatest(fetchList.type, fetchListEffect),
    takeLatest(fetchMore.type, fetchMoreEffect),
    takeLatest(fetchDetail.type, fetchDetailEffect),
    takeLatest(recalculateInvoice.type, recalculateInvoiceEffect),
    takeLatest(runDeepQueue.type, deepQueueEffect),
];
